<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="!dataForm.id ? '新增' : '编辑'" width="680px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="150px" v-loading="dialogLoading">
      <el-form-item prop="name" label="合同名称">
        <el-input v-model="dataForm.name" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item prop="number" label="合同编号">
        <el-input v-model="dataForm.number" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item prop="signingTime" label="签订时间">
        <el-date-picker
          style="width: 100%;"
          v-model="dataForm.signingTime"
          type="date"
          value-format="yyyy/MM/dd"
          placeholder="选择日期时间"
          clearable
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="time" label="起止时间" >
        <el-date-picker
          style="width: 100%;"
          v-model="dataForm.time"
          type="daterange"
          value-format="yyyy/MM/dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="serviceProviderCompanyId" label="服务提供方公司" >
        <el-select style="width: 100%;" v-model="dataForm.serviceProviderCompanyId" placeholder="请选择服务提供方公司" @change="handleServiceChange" filterable autocomplete="off" clearable>
          <el-option v-for="item in allCompany" :key="item.id" :label="item.name" :value="item.id" :disabled='item.id === dataForm.clientCompanyId' ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="serviceProviderTransactorId" label="服务提供方办理人" >
        <el-select style="width: 100%;" v-model="dataForm.serviceProviderTransactorId" placeholder="请选择服务提供方办理人" filterable autocomplete="off" clearable>
          <el-option v-for="item in serversList" :key="item.id" :label="item.nickname" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="clientCompanyId" label="客户公司" >
        <el-select style="width: 100%;" v-model="dataForm.clientCompanyId" placeholder="请选择客户公司" @change="handleClientChange"  filterable autocomplete="off" clearable>
          <el-option v-for="item in allCompany" :key="item.id" :label="item.name" :value="item.id" :disabled='item.id === dataForm.serviceProviderCompanyId' ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="clientTransactorId" label="客户公司办理人" >
        <el-select style="width: 100%;" v-model="dataForm.clientTransactorId" placeholder="请选择客户公司办理人" filterable autocomplete="off" clearable>
          <el-option v-for="item in clientServersList" :key="item.id" :label="item.nickname" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    allCompany: Array
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      serversList: [],
      clientServersList: [],
      dataForm: {
        name: "",
        time: [],
        number: '',
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        signingTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        serviceProviderCompanyId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        serviceProviderTransactorId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientCompanyId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientTransactorId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row) {
      console.log(this.dataForm)
      this.visible = true
      this.dataForm = {
        name: "",
        number: '',
        time: [],
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (row !== null) {
          this.dataForm = Object.assign({}, row)
        }
      })
    },
    handleServiceChange (val) {
      this.dataForm.serviceProviderTransactorId = ''
      this.$api.contract.getListAllUserByCompany(val).then((res) => {
        if (res.success) {
          this.serversList = res.data
        }
      })
    },
    handleClientChange (val) {
      this.dataForm.clientTransactorId = ''
      this.$api.contract.getListAllUserByCompany(val).then((res) => {
        if (res.success) {
          this.clientServersList = res.data
        }
      })
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.dataForm.startTime = this.$moment(this.dataForm.time[0]).format('YYYY/MM/DD')
        this.dataForm.endTime = this.$moment(this.dataForm.time[1]).format('YYYY/MM/DD')
        if (this.dataForm.id) {
          this.$api.contract.addElectricOperationsContract({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        } else {
          this.$api.contract.addElectricOperationsContract({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        }
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
}
</style>
